import _get from 'lodash/get';
import { servicesState } from '../selectors';

const firebaseState = state => _get(servicesState(state), 'firebase');
export const getFirebaseSession = state => _get(firebaseState(state), 'session');
export const getFirebaseUserCompany = state => _get(getFirebaseSession(state), 'user_company');